import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import ReactList from 'react-list'

import { ARItem } from './ar-item'
import { EditARBilling } from './edit-billing'
import { filterAR, sortAR } from '../../function'

import { accountingAction } from '../../../../actions'
import { accountingSelector } from '../../../../selectors'
// import { modalButtons } from '../../../buttons/modal-button'
// import { ViewBilling } from './view-billing'

export const ARDataTable = React.memo(({
  sortOrder,
  openDiscardModal,
  closeResponseModal,
  goToProjectInfo,
}) => {
  const access_token = localStorage.getItem('access_token')
  const dispatch = useDispatch()
  const [isEdit, setIsEdit] = useState(false)
  const [billing, setBillling] = useState({})
  const [defaultBillings, setDefaultBillings] = useState([])

  const keyword = useSelector(accountingSelector.getKeywordSearch)
  const arFilter = useSelector(accountingSelector.getARFilter)

  const _billings = useSelector(accountingSelector.getBillings)

  const billings = sortAR(filterAR(defaultBillings, keyword, arFilter), sortOrder)

  useEffect(() => {
    dispatch(accountingAction.getBillings(access_token))
  }, [])

  useEffect(() => {
    const billings = []
    _billings.map(b => {
      const { billings: __billings = [] } = b
      __billings.map(billing => {
        return billings.push({ ...b, ...billing })
      })
      return b
    })
    setDefaultBillings(billings)
  }, [_billings])

  const editDetail = async (id, billing_id, state) => {
    const payload = {}
    payload.accountant_billing = {
      billing_id,
      status: state.status,
      vat: state.vat,
      revised_invoice_date: state.revised_invoice_date || '',
      actual_invoice_date: state.actual_invoice_date || '',
      invoice_number: state.invoice_number || '',
      cash_receive_date: state.cash_receive_date || '',
      remark: state.remark || '',
    }
    await dispatch(accountingAction.editBilling(id, billing_id, payload, access_token))
    dispatch(accountingAction.getBillings(access_token))
    setIsEdit(false)
  }

  const handleClickEdit = (index, billing_id) => {
    setBillling({ billing: billings[index], billing_id })
    setIsEdit(true)
  }

  const handleClose = () => {
    if (isEdit) {
      const actions = {
        cancel: closeResponseModal,
        discard: () => {
          setIsEdit(false)
          closeResponseModal()
        },
      }
      openDiscardModal(actions)
    } else {
      setIsEdit(false)
    }
  }


  const renderItem = (index) => {
    const item = billings[index]

    return (
      <ARItem
        key={ index }
        index={ index }
        billing={ item }
        item={ item }
        handleClickEdit={ handleClickEdit }
        goToProjectInfo={ goToProjectInfo }
      />
    )
  }
  // const openDiscardModal = actions => {
  //   dispatch(accountingAction.openResponseModal({
  //     responseModal: {
  //       isOpen: true,
  //       res: {
  //         title: 'Unsaved changes',
  //         description: 'Are you sure you want to discard these changes?',
  //         actions: modalButtons('discard', actions),
  //       },
  //     },
  //   }))
  // }

  // const closeResponseModal = () => {
  //   dispatch(accountingAction
  //     .openResponseModal({ responseModal: { isOpen: false, res: {} } }))
  // }

  return (
    <Root>
      <EditARBilling
        isEdit={ isEdit }
        data={ billing }
        handleClose={ handleClose }
        editDetail={ editDetail }
      />
      {/* <ViewBilling
        isView={ isView }
        handleClose={ () => setIsView(false) }
      /> */}
      <RowWrapper>
        <ReactList
          itemRenderer={ renderItem }
          length={ billings.length }
        />
      </RowWrapper>
    </Root>
  )
})

const Root = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

const RowWrapper = styled.div`
  height: 100%;
`



// WEBPACK FOOTER //
// ./src/components/accounting-dashboard/data-table/ar-billing/index.js